// @ts-ignore
import DelivererResult from 'generated/Result/Dispensers/Models/DelivererResult';
// @ts-ignore
import MmtcDashboardResult from 'generated/Result/SystemManagement/Models/MmtcDashboardResult';
// @ts-ignore
// import MmtcProfileDto from 'generated/Result/SystemManagement/Models/MmtcProfileDto';
import {
  GET_DELIVERY_USERS, GET_MMTCS, RESET_MMTCS, GET_MMTC_PROFILE, RESET_MMTC_PROFILE, DELETE_MMTC_PROFILE,
  EDIT_MMTC_PROFILE, ADD_MMTC
} from 'redux/types/dispenser';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface DispenserState {
  deliveryUsers: DelivererResult[],
  deliveryUsersFetched: Boolean,
  getMmtcs: MmtcDashboardResult,
  mmtcProfile: any
  mmtcProfileDeleted: boolean // ,
  // mmtcProfileEdited: boolean,
  // mmtcAdded: any
}

const INITIAL_STATE: DispenserState = {
  deliveryUsers: [],
  deliveryUsersFetched: false,
  getMmtcs: null,
  mmtcProfile: null,
  mmtcProfileDeleted: null // ,
  // mmtcProfileEdited: null,
  // mmtcAdded: null
};

const dispenserReducer = function (state: DispenserState = INITIAL_STATE, action: PayloadAction<any>): DispenserState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;

    case GET_DELIVERY_USERS:
      return { ...state, deliveryUsers: action.payload, deliveryUsersFetched: true };

    case GET_MMTCS:
      return { ...state, getMmtcs: action.payload };

    case RESET_MMTC_PROFILE:
      return { ...state, mmtcProfile: null };

    case RESET_MMTCS:
      return { ...state, getMmtcs: null };

    case GET_MMTC_PROFILE: {
      const mmtcProfileData = {
        ...action.payload,
        countyDropDown: {
          id: action.payload?.county?.countyId,
          name: action.payload?.county?.countyName
        },
        professionDropDown: {
          id: action.payload?.medicalDirectorProfession?.professionId,
          name: (`${action.payload?.medicalDirectorProfession?.description} (${action.payload?.medicalDirectorProfession?.code})`),
          code: action.payload?.medicalDirectorProfession?.code
        }
      };
      return { ...state, mmtcProfile: mmtcProfileData };
    }
    case DELETE_MMTC_PROFILE:
      return { ...state, mmtcProfileDeleted: action.payload };

    case EDIT_MMTC_PROFILE:
      return { ...state, mmtcProfile: action.payload };

    case ADD_MMTC:
      return { ...state, mmtcProfile: action.payload };

    default:
      return state;
  }
};

export default dispenserReducer;
